import { render, staticRenderFns } from "./BitacoraProvider.vue?vue&type=template&id=238cd58e&"
import script from "./BitacoraProvider.vue?vue&type=script&lang=js&"
export * from "./BitacoraProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports